/**
* Gridded Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Gridded Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'gridded-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let tallestCard = 0;
      $( '.gridded-callout__card-description' ).each( function() {
        if ( $( this ).height() > tallestCard ) {
          tallestCard = $( this ).height();
        }
      } );
      $( '.gridded-callout__card-description' ).each( function() {
        $( this ).height( tallestCard );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'gridded-callout', COMPONENT );
} )( app );
